{% block swag_migration_base_content_view %}
    <div class="swag-migration-wizard">
        <sw-modal
            v-if="showModal"
            class="swag-migration-wizard__modal"
            :size="modalSize"
            :title="$tc(modalTitleSnippet)"
            :is-loading="isLoading || storesInitializing"
            @modal-close="onCloseModal"
        >
            {% block swag_migration_wizard_placeholder %}
                <div
                    v-show="isLoading || storesInitializing || childIsLoading"
                    class="swag-migration-wizard__placeholder">

                </div>
            {% endblock %}

            {% block swag_migration_router_view %}
                <router-view v-slot="{ Component }">
                    <component
                        :is="Component"
                        v-show="!isLoading && !childIsLoading && !storesInitializing"
                        :current-connection-id="connection?.id"
                        :credentials-component="credentialsComponent"
                        :credentials="connection?.credentialFields"
                        :error-message-snippet="errorMessageSnippet"
                        :error-message-hint-snippet="errorMessageHintSnippet"
                        :connection-name-error-code="connectionNameErrorCode"
                        @on-child-route-ready-changed="onChildRouteReadyChanged"
                        @on-trigger-primary-click="triggerPrimaryClick"
                        @on-profile-selected="onProfileSelected"
                        @on-change-connection-name="onChangeConnectionName"
                        @on-connection-selected="onConnectionSelected"
                        @on-credentials-changed="onCredentialsChanged"
                        @on-is-loading-changed="onChildIsLoadingChanged"
                    />
                </router-view>
            {% endblock %}

            <template #modal-footer>
                <div class="swag-migration-wizard__footer">
                    {% block swag_migration_wizard_footer %}
                        {% block swag_migration_wizard_actions %}
                            <div class="swag-migration-wizard__right-actions">
                                {% block swag_migration_wizard_actions_previous %}
                                    <mt-button v-show="buttonSecondaryVisible"
                                               variant="secondary"
                                               size="small"
                                               @click="onButtonSecondaryClick">
                                        {{ $tc(buttonSecondarySnippet) }}
                                    </mt-button>
                                {% endblock %}

                                {% block swag_migration_wizard_actions_next %}
                                    <mt-button size="small"
                                               variant="primary"
                                               :disabled="buttonPrimaryDisabled"
                                               @click="onButtonPrimaryClick">
                                        {{ $tc(buttonPrimarySnippet) }}
                                    </mt-button>
                                {% endblock %}
                            </div>
                        {% endblock %}
                    {% endblock %}
                </div>
            </template>
        </sw-modal>
    </div>
{% endblock %}
